import { render, staticRenderFns } from "./case-logs.vue?vue&type=template&id=32caa00d"
import script from "./case-logs.vue?vue&type=script&lang=js"
export * from "./case-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports